import styled from 'styled-components';

import * as Base from './locked-offers-card.styled.default';

export const Container = styled(Base.Container)`
  background-color: ${Styles.color.cardBackground};
`;

export const CardFooter = styled(Base.CardFooter)`
  display: flex;
  justify-content: space-between;
  height: 2rem;
`;

export const Countdown = styled(Base.Countdown)`
  justify-content: flex-end;
`;

export * from './locked-offers-card.styled.default';
